export class NumberHelper {
  public static AlwaysTwoDecimals = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  public static UpToTwoDecimals = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });

  public static format(number: number | undefined, formatter: Intl.NumberFormat = NumberHelper.AlwaysTwoDecimals) {
    if (number === undefined || typeof number !== 'number') {
      return;
    }

    return formatter.format(number);
  }

  public static parseFloat(value: string, fallback = 0) {
    return parseFloat(value) || fallback;
  }

  public static isNullOrUndefined(value?: number) {
    return !value && value !== 0;
  }
}
